import { useFormikContext } from "formik";
import React from "react";
import _, { uniqueId } from "lodash";

import { FlatApplciationType } from "../../../types";
import Person from "./Person";
import { ChildDataType } from "csv-package";

const Persons: React.FC<{ id?: string }> = ({ id = "person" }) => {
  const { values, setFieldValue } = useFormikContext<FlatApplciationType>();
  const protected_persons = values.protected_persons as ChildDataType[];

  const personGroup = React.useMemo(
    () =>
      Array.isArray(protected_persons)
        ? (protected_persons).filter(({ prp_id }) => String(prp_id).startsWith(id))
        : [],
    [protected_persons, id]
  );

  const addChild = React.useCallback(() => {
    const newChild = {
      prp_id: uniqueId(id),
    };
    if (_.isEmpty(personGroup)) {
      setFieldValue("protected_persons", [newChild]);
    } else {
      setFieldValue("protected_persons", [...personGroup, newChild]);
    }
  }, [personGroup, setFieldValue, id]);

  const removeChild = React.useCallback(
    (id: string) => {
      setFieldValue(
        "protected_persons",
        protected_persons.filter(({ prp_id }) => prp_id !== id)
      );
    },
    [protected_persons, setFieldValue]
  );

  React.useEffect(() => {
    if (_.isEmpty(personGroup)) {
      addChild();
    }
  }, [values.app_types, personGroup, addChild]);

  return (
    <>
      {personGroup.map(({ prp_id }, index) => (
        <Person
          key={index}
          personIndex={index}
          personId={String(prp_id)}
          addPerson={addChild}
          removePerson={removeChild}
        />
      ))}
    </>
  );
};

export default Persons;
